export class DeveloperIdResponse {
  constructor() {
    this.id = 0;
    this.profileId = 0;
  }
  public id: number;
  public profileId: number;
}
